import vanillaPicker from './vanilla-picker.js';

export default {
    vanillaPicker
};
